// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/scrollbars.module.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QHpS9X7WhsWPs_iTsoiz {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-height: 120px;
}

.M7LNbuQSk96aX_l8vTZF {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.ZkeB98M2kqTeHTaWndAF,
.iiYft9fPs9DOOL8Cqy6z {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid var(--border-subtle, #e2e4e8);
  background: var(--surface-raised, #fff);
  cursor: pointer;
  font: inherit;
  font-size: 12px;
}

.iiYft9fPs9DOOL8Cqy6z {
  border-color: var(--accent, #e85d2a);
  background: color-mix(in srgb, var(--accent, #e85d2a) 8%, white);
}

.j5Yx4JglH47cerfzaUl2 {
  font-weight: 600;
  color: var(--text-primary, #1a1d21);
}

.QWD5HFqEuNLanu52ZDTD {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--text-muted, #6b7280);
}

/* \`overflow: hidden\` clipped a wide bundle table with no way to reach the
   right-hand columns (#345) - the #203 defect on a sibling surface. \`auto\`
   keeps the border-radius clipping this rule was also doing, and the table
   inside is TabularPreviewTable, which already carries the other two thirds of
   the fix (\`overflowX: visible\` on its container, \`minWidth: max-content\` on
   the table). Its scrollbar is the shared thin one, as on
   DatasetTablePreview.module.css, which is the same component getting this
   right. */
.rjItGSM3tR7h9Hj3ERko {
  border: 1px solid var(--border-subtle, #e2e4e8);
  border-radius: 8px;
  overflow: auto;
}

.GQTchS8I7kCxCoqrtVYa {
  opacity: 0.6;
  transition: opacity 120ms ease;
}

.iR9_rku81lIi4QrfG1If {
  margin: 8px 12px 10px;
  font-size: 11px;
  color: var(--text-muted, #6b7280);
}

.gnaLrra3T3sIiLacwNpQ {
  padding: 16px;
  font-size: 13px;
  color: var(--text-muted, #6b7280);
}
`, "",{"version":3,"sources":["webpack://./src/components/datasets/catalog/DatasetBundlePreview.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,+CAA+C;EAC/C,uCAAuC;EACvC,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,gEAAgE;AAClE;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;;;;;;;WAOW;AACX;EAEE,+CAA+C;EAC/C,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iCAAiC;AACnC","sourcesContent":[".panel {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  min-height: 120px;\n}\n\n.tabBar {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.tab,\n.tabActive {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  padding: 6px 10px;\n  border-radius: 8px;\n  border: 1px solid var(--border-subtle, #e2e4e8);\n  background: var(--surface-raised, #fff);\n  cursor: pointer;\n  font: inherit;\n  font-size: 12px;\n}\n\n.tabActive {\n  border-color: var(--accent, #e85d2a);\n  background: color-mix(in srgb, var(--accent, #e85d2a) 8%, white);\n}\n\n.tabLabel {\n  font-weight: 600;\n  color: var(--text-primary, #1a1d21);\n}\n\n.tabFormat {\n  font-size: 10px;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: var(--text-muted, #6b7280);\n}\n\n/* `overflow: hidden` clipped a wide bundle table with no way to reach the\n   right-hand columns (#345) - the #203 defect on a sibling surface. `auto`\n   keeps the border-radius clipping this rule was also doing, and the table\n   inside is TabularPreviewTable, which already carries the other two thirds of\n   the fix (`overflowX: visible` on its container, `minWidth: max-content` on\n   the table). Its scrollbar is the shared thin one, as on\n   DatasetTablePreview.module.css, which is the same component getting this\n   right. */\n.tableWrap {\n  composes: thinScrollbar from \"../../../styles/scrollbars.module.css\";\n  border: 1px solid var(--border-subtle, #e2e4e8);\n  border-radius: 8px;\n  overflow: auto;\n}\n\n.tableRefreshing {\n  opacity: 0.6;\n  transition: opacity 120ms ease;\n}\n\n.partNote {\n  margin: 8px 12px 10px;\n  font-size: 11px;\n  color: var(--text-muted, #6b7280);\n}\n\n.state {\n  padding: 16px;\n  font-size: 13px;\n  color: var(--text-muted, #6b7280);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `QHpS9X7WhsWPs_iTsoiz`,
	"tabBar": `M7LNbuQSk96aX_l8vTZF`,
	"tab": `ZkeB98M2kqTeHTaWndAF`,
	"tabActive": `iiYft9fPs9DOOL8Cqy6z`,
	"tabLabel": `j5Yx4JglH47cerfzaUl2`,
	"tabFormat": `QWD5HFqEuNLanu52ZDTD`,
	"tableWrap": `rjItGSM3tR7h9Hj3ERko ${___CSS_LOADER_ICSS_IMPORT_0___.locals["thinScrollbar"]}`,
	"tableRefreshing": `GQTchS8I7kCxCoqrtVYa`,
	"partNote": `iR9_rku81lIi4QrfG1If`,
	"state": `gnaLrra3T3sIiLacwNpQ`
};
export default ___CSS_LOADER_EXPORT___;
